module.exports = "/_next/static/images/offers2-038e97b2f510f65ebc7168a68206fb2a.jpg.webp";